import React from "react"

export const EquifaxDitReport = ({ item, onClick }) => {
  const report = item.report

  return <div onClick={onClick} className="cr-header">
    <h5>Digital Identity Trust: {item.customerName}</h5>
    <div>Decision: <b>{report.decision}</b></div>

    {item.ofacAlerts?.length ? <div className="alert alert-danger my-3">
      <h6 className="mb-0">OFAC Alerts</h6>
      {item.ofacAlerts?.map((alert, i) => <div key={i}>{alert.key}: {alert.value}</div>)}
    </div> : null}
  </div>
}

export default EquifaxDitReport